var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgReport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 60,
    viewBox: "0 0 45 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M45 15H31.875C31.3777 15 30.9008 14.8025 30.5492 14.4508C30.1975 14.0992 30 13.6223 30 13.125V8.83393e-06H2.81251C2.44409 -0.000915681 2.07909 0.0707348 1.73837 0.210869C1.39764 0.351004 1.08785 0.556878 0.826681 0.816737C0.565516 1.0766 0.358091 1.38535 0.216251 1.72537C0.0744101 2.0654 0.000931035 2.43003 8.83393e-06 2.79845V57.1875C-0.000915681 57.5559 0.0707348 57.9209 0.210869 58.2617C0.351004 58.6024 0.556878 58.9122 0.816737 59.1733C1.0766 59.4345 1.38535 59.6419 1.72537 59.7838C2.0654 59.9256 2.43003 59.9991 2.79845 60H42.1875C42.5559 60.0009 42.9209 59.9293 43.2616 59.7891C43.6024 59.649 43.9122 59.4431 44.1733 59.1833C44.4345 58.9234 44.6419 58.6147 44.7838 58.2746C44.9256 57.9346 44.9991 57.57 45 57.2016V15ZM15.9926 51.3867C14.3197 50.7312 12.8004 49.7371 11.5299 48.4666C10.2594 47.1961 9.26527 45.6768 8.60977 44.0039C5.09415 34.9383 10.6535 26.3438 18.75 24.6867V41.25H35.3133C33.6563 49.3465 25.0617 54.9117 15.9926 51.3867ZM22.5 37.5V23.4211C24.349 23.4208 26.1799 23.7847 27.8881 24.4922C29.5964 25.1996 31.1486 26.2366 32.456 27.544C33.7634 28.8514 34.8004 30.4036 35.5078 32.1119C36.2153 33.8201 36.5792 35.6511 36.5789 37.5H22.5Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1802 12.3047L32.7076 0.820321C32.4457 0.559368 32.135 0.3526 31.7931 0.211843C31.4513 0.0710858 31.0851 -0.000898088 30.7154 8.45708e-06H30.0005V13.125C30.0005 13.6223 30.1981 14.0992 30.5497 14.4508C30.9013 14.8025 31.3783 15 31.8755 15H45.0005V14.2852C45.0005 13.9174 44.9281 13.5532 44.7874 13.2133C44.6466 12.8735 44.4403 12.5648 44.1802 12.3047ZM18.7505 24.6867C10.654 26.3438 5.08879 34.9383 8.61028 44.0039C9.26578 45.6768 10.26 47.1961 11.5304 48.4666C12.8009 49.7371 14.3202 50.7312 15.9931 51.3867C25.0622 54.9117 33.6568 49.3465 35.3138 41.25H18.7505V24.6867Z",
    fill: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 22.5,
    y1: 0,
    x2: 22.5,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 26.2669,
    y1: 0,
    x2: 26.2669,
    y2: 52.4656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 60,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgReport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/report.26b798cd3dc9b5a44fffe65f09d4431f.svg";